import { useApp } from "@/lib/AppContext";
import SharedHeader from "@/components/SharedHeader";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import ServicesSection from "@/components/landing/ServicesSection";
import PromoSection from "@/components/landing/PromoSection";
import OfferBanners from "@/components/landing/OfferBanners";
import ReviewsSection from "@/components/landing/ReviewsSection";
import AboutSection from "@/components/landing/AboutSection";
import LandingFooter from "@/components/landing/LandingFooter";
import FloatingContactButtons from "@/components/FloatingContactButtons";
import MobileBottomNav from "@/components/landing/MobileBottomNav";

export default function LandingPage() {
  const { lang } = useApp();
  const isAr = lang === "ar";

  return (
    <div className="min-h-screen bg-background" dir={isAr ? "rtl" : "ltr"}>
      <SharedHeader />
      <div className="pt-16 pb-24 md:pb-0">
        <HeroSection />
        <OfferBanners />
        <AboutSection />
        <FeaturesSection />
        <ServicesSection />
        <PromoSection />
        <ReviewsSection />
        <LandingFooter />
        <FloatingContactButtons />
      </div>
      <MobileBottomNav />
    </div>
  );
}